<div class="confirm" *ngIf="openConfirm">
  <div class="container">
    <p class="title">Obrigado!!</p>
    <p>Quando a campanha for ativada, você receberá um link de um relatório para acompanhar o status e a performance da sua campanha.</p>
    <p>Enviaremos o boleto para pagamento do valor do investimento no seu email. Sua campanha deve ir ao ar durante a primeira semana do mês. Vale lembrar que o pagamento do boleto é determinante para ativação da campanha.</p>
    <p>Boas vendas!</p>
    <lib-button-primary class="btn-confirm" (click)="confirm()">Ok</lib-button-primary>
  </div>
</div>